import { Component, Input, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { gcManagementEnumerations } from '../../../interfaces/interfaces.module';

@Component({
    selector: 'app-group-classes-category-icon',
    templateUrl: './group-classes-category-icon.component.html',
    styleUrls: ['./group-classes-category-icon.component.scss'],
    standalone: false
})
export class GroupClassesCategoryIconComponent implements OnInit {
    private iconsPath = '';

    @Input() public category: string = 'general';

    @Input() public status: string = gcManagementEnumerations.GroupClassStatus.active.code;

    constructor() {}

    ngOnInit() {
        this.iconsPath = environment.categoryIconsCDN + '{iconName}.svg';
    }

    public iconPath() {
        var iconName = (this.category + '_' + this.status).replace(/\s/g, '');

        return this.iconsPath.replace('{iconName}', iconName);
    }
}
